import { styled } from 'styled-components'

import { FlexBox } from '../Base/FlexBox'

interface EsignFullScreenWrapProps {
  title: React.ReactNode
  children: React.ReactNode
}

export function EsignFullScreenWrap({ children, title }: EsignFullScreenWrapProps) {
  return (
    <FlexBox isColumn styles="flex: 1;">
      {title}
      <EnvelopeWrap>{children}</EnvelopeWrap>
      <style>{`.content { display: flex; flex-direction: column; }`}</style>
    </FlexBox>
  )
}

const EnvelopeWrap = styled.div`
  flex: 1;
`
